import "./index-image-container.css"

function IndexImageContainer(props) {
    return (<>
    <div className="index-image-container">

        {props.children}
    </div>

    </>)
}

export default IndexImageContainer
